
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexaYCbqHQMAuERJqiREzAK63yjXoWzCk_li0jvxGr2LHwMeta } from "/usr/app/pages/index.vue?macro=true";
import { default as loginz0y5RiYgbFCIrmyOWfbanHltR6Wt5eXYu3JT6ATIDXUMeta } from "/usr/app/pages/login.vue?macro=true";
import { default as resetRD6bN6g8QQqUzC951fCT10jBiUnheHjvYKXilLvLP4IMeta } from "/usr/app/pages/reset.vue?macro=true";
import { default as termsH6OTd0s1dYX996DjjfaLIYsACRr3q2lD8dUp5hQRd1gMeta } from "/usr/app/pages/terms.vue?macro=true";
import { default as forgotNcFc16nZ3W6oTJmGFRWVg1NUHsf2pZqa2vVa_HWecU8Meta } from "/usr/app/pages/forgot.vue?macro=true";
import { default as resendCH83pz6AwTSHjh5FdY0KgJYe9DnzRYmRXBoJum7vA5sMeta } from "/usr/app/pages/resend.vue?macro=true";
import { default as privacyWheb2VH62P1D8hwCckwz0cHItKLN920guuO_45zLcOI_4Meta } from "/usr/app/pages/privacy.vue?macro=true";
import { default as activatew_QFUaCPqhCn3aoEscssaJjQQCK8aou_gCBpYX6vNpsMeta } from "/usr/app/pages/activate.vue?macro=true";
import { default as registerKo2QJQrQm8a7SQ8nbYIO2hUW7dALPi91ssygOJGNJAUMeta } from "/usr/app/pages/register.vue?macro=true";
import { default as indexrXyZ0NDuJmVpAj_459k28En19QxZCdmJWPvakvsZ3UeIwMeta } from "/usr/app/pages/app/index.vue?macro=true";
import { default as payoutsIe0hX4bba9_dHuTRQRoC63aAUWykuhZ6XTFgopm1lzwMeta } from "/usr/app/pages/app/payouts.vue?macro=true";
import { default as payments1Zh3pF4EougZX9YhgXgsk0lBOlTSH9bqfem30tnZcFIMeta } from "/usr/app/pages/app/payments.vue?macro=true";
import { default as _91id_93qS0ffDVYdr68eMiWeLuPhaP0q5rIj_45VIUDtZr1u0R0YMeta } from "/usr/app/pages/payment/[id].vue?macro=true";
import { default as settlements4dv8EIOiUUS8dLYNFWejFadzv8Kom8ISmQ1sKst701EMeta } from "/usr/app/pages/app/settlements.vue?macro=true";
import { default as apiis3AGlntnJT84ctU1HJjQGMMjgslwyMRDrxA3VOzUXoMeta } from "/usr/app/pages/app/settings/api.vue?macro=true";
import { default as accounttJXQIp7bquu4jj5Vxnv1XKf5uVWo3usUz0pmWROqwmEMeta } from "/usr/app/pages/app/settings/account.vue?macro=true";
import { default as generaloTnY4rR2F7UKtRKz4Cmh_sYfCkE30R_gcK2paVOYVTMMeta } from "/usr/app/pages/app/settings/general.vue?macro=true";
import { default as paymentstyuMqWQRdenfw60XbPSVSQ9nC7H8OCDQYJ5zO9Yyty4Meta } from "/usr/app/pages/app/settings/payments.vue?macro=true";
import { default as settlementsQkOjnstIX8H9LIw10p305T5M60P0G2wTVCK2P_qu42AMeta } from "/usr/app/pages/app/settings/settlements.vue?macro=true";
export default [
  {
    name: "home",
    path: "/",
    meta: indexaYCbqHQMAuERJqiREzAK63yjXoWzCk_li0jvxGr2LHwMeta || {},
    component: () => import("/usr/app/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: { ...(loginz0y5RiYgbFCIrmyOWfbanHltR6Wt5eXYu3JT6ATIDXUMeta || {}), ...{"middleware":["guest"]} },
    component: () => import("/usr/app/pages/login.vue")
  },
  {
    name: "reset",
    path: "/reset",
    meta: { ...(resetRD6bN6g8QQqUzC951fCT10jBiUnheHjvYKXilLvLP4IMeta || {}), ...{"middleware":["guest"]} },
    component: () => import("/usr/app/pages/reset.vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: termsH6OTd0s1dYX996DjjfaLIYsACRr3q2lD8dUp5hQRd1gMeta || {},
    component: () => import("/usr/app/pages/terms.vue")
  },
  {
    name: "forgot",
    path: "/forgot",
    meta: { ...(forgotNcFc16nZ3W6oTJmGFRWVg1NUHsf2pZqa2vVa_HWecU8Meta || {}), ...{"middleware":["guest"]} },
    component: () => import("/usr/app/pages/forgot.vue")
  },
  {
    name: "resend",
    path: "/resend",
    meta: { ...(resendCH83pz6AwTSHjh5FdY0KgJYe9DnzRYmRXBoJum7vA5sMeta || {}), ...{"middleware":["guest"]} },
    component: () => import("/usr/app/pages/resend.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    meta: privacyWheb2VH62P1D8hwCckwz0cHItKLN920guuO_45zLcOI_4Meta || {},
    component: () => import("/usr/app/pages/privacy.vue")
  },
  {
    name: "activate",
    path: "/activate",
    meta: { ...(activatew_QFUaCPqhCn3aoEscssaJjQQCK8aou_gCBpYX6vNpsMeta || {}), ...{"middleware":["guest"]} },
    component: () => import("/usr/app/pages/activate.vue")
  },
  {
    name: "register",
    path: "/register",
    meta: { ...(registerKo2QJQrQm8a7SQ8nbYIO2hUW7dALPi91ssygOJGNJAUMeta || {}), ...{"middleware":["guest"]} },
    component: () => import("/usr/app/pages/register.vue")
  },
  {
    name: "dashboard",
    path: "/app",
    meta: { ...(indexrXyZ0NDuJmVpAj_459k28En19QxZCdmJWPvakvsZ3UeIwMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/usr/app/pages/app/index.vue")
  },
  {
    name: "app-payouts",
    path: "/app/payouts",
    meta: { ...(payoutsIe0hX4bba9_dHuTRQRoC63aAUWykuhZ6XTFgopm1lzwMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/usr/app/pages/app/payouts.vue")
  },
  {
    name: "app-payments",
    path: "/app/payments",
    meta: { ...(payments1Zh3pF4EougZX9YhgXgsk0lBOlTSH9bqfem30tnZcFIMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/usr/app/pages/app/payments.vue")
  },
  {
    name: "payment-id",
    path: "/payment/:id()",
    component: () => import("/usr/app/pages/payment/[id].vue")
  },
  {
    name: "app-settlements",
    path: "/app/settlements",
    meta: { ...(settlements4dv8EIOiUUS8dLYNFWejFadzv8Kom8ISmQ1sKst701EMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/usr/app/pages/app/settlements.vue")
  },
  {
    name: "app-settings-api",
    path: "/app/settings/api",
    meta: { ...(apiis3AGlntnJT84ctU1HJjQGMMjgslwyMRDrxA3VOzUXoMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/usr/app/pages/app/settings/api.vue")
  },
  {
    name: "app-settings-account",
    path: "/app/settings/account",
    meta: { ...(accounttJXQIp7bquu4jj5Vxnv1XKf5uVWo3usUz0pmWROqwmEMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/usr/app/pages/app/settings/account.vue")
  },
  {
    name: "app-settings-general",
    path: "/app/settings/general",
    meta: { ...(generaloTnY4rR2F7UKtRKz4Cmh_sYfCkE30R_gcK2paVOYVTMMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/usr/app/pages/app/settings/general.vue")
  },
  {
    name: "app-settings-payments",
    path: "/app/settings/payments",
    meta: { ...(paymentstyuMqWQRdenfw60XbPSVSQ9nC7H8OCDQYJ5zO9Yyty4Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/usr/app/pages/app/settings/payments.vue")
  },
  {
    name: "app-settings-settlements",
    path: "/app/settings/settlements",
    meta: { ...(settlementsQkOjnstIX8H9LIw10p305T5M60P0G2wTVCK2P_qu42AMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/usr/app/pages/app/settings/settlements.vue")
  }
]